import dependencyMap from "./fieldDependencyMap";
import validatorMap from "./fieldValidatorMap";
import elementValidatorMap from "./fieldElementValidatorMap";
import { checkCustomValidity, getValidateFieldNames, updateDependents, } from "./helpers";
const doWindow = window;
export default class GmFinanceForm {
    constructor(sendFormData) {
        this.addListeners = () => {
            this._form.SubmitBtn.addEventListener("click", this.handleSubmit);
            this._form.FirstName.addEventListener("blur", () => doWindow.DealeronLead.begin(), { once: true });
            const fieldNames = getValidateFieldNames();
            for (const name of fieldNames) {
                const field = this.findValidationElementForField(name);
                if (!field) {
                    continue;
                }
                field.addEventListener("change", (ev) => {
                    ev.stopPropagation();
                    if (validatorMap[name]) {
                        checkCustomValidity(field, false, name);
                    }
                    if ((field.validity.valid || field.type === "select-one") &&
                        dependencyMap[name]) {
                        updateDependents(field);
                    }
                });
            }
            // Run updates to account for page refreshes
            for (const name in dependencyMap) {
                const field = this._form[name];
                if (field) {
                    updateDependents(field);
                }
            }
        };
        this.findValidationElementForField = (name) => {
            // Check if the field has a custom validation element to listen to instead of itself
            if (elementValidatorMap[name]) {
                const validationElement = this._form.querySelector(elementValidatorMap[name]);
                if (validationElement) {
                    return validationElement;
                }
            }
            return this._form[name];
        };
        this.handleSubmit = () => {
            if (!this._form.reportValidity()) {
                return;
            }
            this._form.SubmitBtn.setAttribute("disabled", "true");
            let customValidity = true;
            const names = Object.keys(validatorMap);
            for (const name of names) {
                const field = this.findValidationElementForField(name);
                if (!field) {
                    continue;
                }
                checkCustomValidity(field, true, name);
                let dependentsValid = true;
                if (field.validity.valid) {
                    dependentsValid = updateDependents(field);
                }
                if (customValidity && !(field.validity.valid && dependentsValid)) {
                    customValidity = false;
                }
            }
            // documentation unclear if reportValidity() on forms detects custom validity failures.
            if (!this._form.reportValidity() || !customValidity) {
                this._form.SubmitBtn.removeAttribute("disabled");
                return;
            }
            this._sendFormData(this._form);
        };
        this._form = document.getElementById("gmFinanceForm");
        this._sendFormData = sendFormData;
        this.addListeners();
    }
}
